export default "__VITE_ASSET__wgZsHr$A__"